import React,{useContext,useState,useEffect} from 'react';
import { MyContext } from '../contexts/MyContext';
import { WEB_URL_UPLOAD } from '../contexts/Apilinks';
import {Oval} from 'react-loader-spinner';
import {Link } from "react-router-dom"; 
import Layout from "../components/layout/Layout";
import {FaAngleDoubleRight, FaLongArrowAltRight } from "react-icons/fa";
import Moment from 'react-moment';
import SEO from './utils/SEO';
let BaseURLuploads = WEB_URL_UPLOAD;


const Interviews = () => {
  const {Allinterviewlist} = useContext(MyContext);
       
  const [page, setPage] = useState(1);
  useEffect(() => {
    gpostFeatured(page);
    window.scrollTo(0, 0);
  }, []);
  const [ispostloademore, setpostloademore] = useState(false);
  const [loademoreloding, setloademoreloding] = useState(false);
  const [islatestbooks, setlatestbooks] = useState([]);
  const [islatestauthors, setlatestauthors] = useState([]);
  const gpostFeatured = async(page) =>{
    try {
      setloademoreloding(true);
      const gpostPlatinumsss = await Allinterviewlist(page);
      if(gpostPlatinumsss.success === true){
        setlatestauthors(gpostPlatinumsss.listauthors?.data);
        if(gpostPlatinumsss.bookslist.data.length > 0){
          setlatestbooks(prevBooks => {
            return [...prevBooks, ...gpostPlatinumsss.bookslist.data]
          })
          setpostloademore(false);
          setloademoreloding(false);
        }else{
          setpostloademore(true);
          setloademoreloding(false);
        }                        
      }
      if(gpostPlatinumsss.success === false){
        setpostloademore(true);
          setloademoreloding(false);
      }
    } catch (error) { throw error;}      
  } 
       const [count, setCount] = useState(1);
       const handleIncrement = (count) => {
              setCount(prevCount => prevCount + 1);
              console.log('count',count+1);
              gpostFeatured(count+1);
       };

    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]{11,11}).*/;

  return (<>
    <Layout>
    <SEO
      title={`${islatestauthors[0]?.title}`}
      description={`${islatestauthors[0]?.name}`}
      image={`${islatestauthors[0]?.profileimg}`}
      slug='/Interviews'
    />
    
    <div className="default__section__list" >
    <div className="container" >
      <div className="row " >
      <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 " >
      <div className="interview__profilesss" >
      {islatestauthors?.map((item,index)=>(
        <div className="interview__profilesss2"  key={index}>
          <div className="profile__img2">
          <Link to={`/AuthorPage/${item.register_id}`}>
          {item.profileimg !== '' && <>
            <img src={BaseURLuploads +item.profileimg} alt="AuthorsPhoto" />
          </> }
            
              <div className="profile__imgcontent2">
                <h4> {item.name} </h4>
                <p> <Moment format="DD MMM YYYY" withTitle>{item.date} 
                      </Moment> </p>
                <span> View Profile </span>
              </div>
            </Link>
            </div>

        </div>
      ))}
      </div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8 " >
        <div className="breadcrumbs" >
            <h1> Author <span> Interviews </span></h1>
        </div>
        <div className=" interviews__paginations" >
      {islatestbooks.map((item,index)=>(
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 "  key={index}>
          
          <div className='default__pagelist interview__innerpages'> 
          <Link to={`/InterviewsPreview/${item.interviews_id}/${item.title.replace(/[^A-Z0-9]/ig, "-")}`}>
            <h1 className="default__pagetitle"> {item.title}</h1>
            </Link>


              {item.types === 'questions and answers' &&
                      <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.answer }} />
                    }
                    {item.types === 'generated' && <div className='ga__sss'> 
                      {item.qone !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qone }} /> }
                      {item.qtwo !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qtwo }} /> }
                      {item.qthree !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qthree }} /> }
                      {item.qfour !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qfour }} /> }
                      {item.qfive !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qfive }} /> }
                      {item.qsix !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qsix }} /> }
                      {item.qseven !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qseven }} /> }
                      {item.qeight !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qeight }} /> }
                      {item.qnine !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qnine }} /> }
                      {item.qten !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qten }} /> }
                      {item.qellavan !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qellavan }} /> }
                      {item.qtwelve !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qtwelve }} /> }
                      {item.qthirteen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qthirteen }} /> }
                      {item.qfourteen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qfourteen }} /> }
                      {item.qfiveteen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qfiveteen }} /> }
                      {item.qsixteen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qsixteen }} /> }
                      {item.qseventeen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qseventeen }} /> }
                      {item.qeighteen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qeighteen }} /> }
                      {item.qnineteen !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qnineteen }} /> }
                      {item.qtwinty !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qtwinty }} /> }
                      {item.qtwintyone !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qtwintyone }} /> }
                      {item.qtwintytwo !== '' &&  <div className="default__desc IH__qa__desc" dangerouslySetInnerHTML={{ __html: item.qtwintytwo }} /> }
   
                    </div>}

            <Link to={`/InterviewsPreview/${item.interviews_id}/${item.title.replace(/[^A-Z0-9]/ig, "-")}`}>
            <p className="default__btns"> Read More  <FaLongArrowAltRight /> </p>
            </Link>
          </div>
         
        </div>
      ))}
      
      <div className="clearfix"></div>
{ispostloademore === false ? 
       <div className="loading" >
              {loademoreloding  ?
              <>
                    <Oval color="#f1592b" height={37} width={37} style={{float: "right",marginTop:"7px",display:"block",width:"100%"}}/>
              </>: 
                     <button className="pagination__buttonsss"  onClick={()=>handleIncrement(count)}> Next <FaAngleDoubleRight />  </button>
              }
       </div>
: null }
 </div>
      
          


      

    </div>
    </div>
  </div>
  </div>
              
   </Layout>
  </>
       )
}

export default Interviews
